module.exports = __webpack_public_path__ + "static/media/velour13F.54c9e187.jpg";